<template>
  <div class="stat-left">
    <div class="stat-left-top">
      <div class="stat-left-top-item" v-for="item in statList" :key="item.icon">
        <img :src="item.icon" />
        <div class="stat-left-top-item-right">
          <div class="stat-left-top-item-right-text">{{ item.text }}</div>
          <div class="stat-left-top-item-right-total">{{ item.total }}</div>
        </div>
      </div>
    </div>
    <div class="stat-left-line"></div>
    <div class="stat-left-charts">
      <div
        class="stat-left-charts-item"
        v-for="item in chartList"
        :key="item.el"
      >
        <EchartCommon
          :el="item.el"
          :text="item.text"
          :echartStyle="{ width: '316px', height: '220px' }"
          v-loading="loading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import echarts from 'echarts'
import EchartCommon from '../EchartCommon.vue'
import { mapGetters } from 'vuex'
import { getMonthDays, initLine, initPie } from '../echartOptions'
import moment from 'moment'
import { onlineDuration } from '@/utils/common'
import {
  yesterdayDate,
  monthStartDate,
  monthEndDate,
  oneMonthAgoStartDate,
  oneMonthAgoEndDate,
} from '../constantDate'

export default {
  name: 'AllStatLeft',
  components: {
    EchartCommon,
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      allOverview: 'statPage/allOverview',
      regionStat: 'statPage/regionStat',
      regionChildStat: 'statPage/regionChildStat',
    }),
    regionId() {
      return +this.$route.query.regionId
    },
    regionName() {
      return this.$route.query.regionName
    },
    regionCode() {
      return this.$route.query.regionCode
    },
    regionHasChild() {
      return _.includes(this.regionCode, '_full')
    },
    overviewByRegion() {
      return _.get(
        this.allOverview,
        `${this.regionId}&${yesterdayDate}&${yesterdayDate}`,
        {}
      )
    },
    curMonth() {
      return moment().format('YYYYMM')
    },
    curMonthDays() {
      return getMonthDays(this.curMonth)
    },
    curMonthStat() {
      const key = `${this.regionId}&${monthStartDate}&${monthEndDate}`
      return this.regionStat[key] || []
    },
    oneMonthAgo() {
      return moment().subtract(1, 'months').format('YYYYMM')
    },
    oneMonthAgoDays() {
      return getMonthDays(this.oneMonthAgo)
    },
    oneMonthAgoStat() {
      const key = `${this.regionId}&${oneMonthAgoStartDate}&${oneMonthAgoEndDate}`
      return this.regionStat[key] || []
    },
    oneMonthAgoChildStat() {
      const key = `${this.regionId}&${oneMonthAgoStartDate}&${oneMonthAgoEndDate}`
      return this.regionChildStat[key] || []
    },
    regionChildList() {
      return Object.keys(this.oneMonthAgoChildStat)
    },
    yesterdayChildStat() {
      const key = `${this.regionId}&${yesterdayDate}&${yesterdayDate}`
      return this.regionChildStat[key] || []
    },
    statList() {
      const {
        studentActiveCount = 0,
        durationIncr = 0,
        activeStudentIncrement = 0,
        teacherIncrement = 0,
      } = this.overviewByRegion
      return [
        {
          icon: require('@/assets/stat/icon1.png'),
          text: '昨日活跃（人）',
          total: studentActiveCount,
        },
        {
          icon: require('@/assets/stat/icon4.png'),
          text: '昨日平均在线时长',
          total: onlineDuration(durationIncr, studentActiveCount),
        },
        {
          icon: require('@/assets/stat/icon3.png'),
          text: '昨日新增学生（人）',
          total: activeStudentIncrement,
        },
        {
          icon: require('@/assets/stat/icon5.png'),
          text: '昨日新增教师（人）',
          total: teacherIncrement,
        },
      ]
    },
    chartList() {
      const activeStudentIncrementList = []
      const activeStudentTotalList = []
      const userActiveCountList = []
      // const vipActiveCountList = []
      // const vipIncrementList = []
      // const vipTotalList = []
      const curMonthActiveCountList = []
      const oneMonthActiveCountList = []
      const userIncrementList = []
      const notChildUsersGrowByRegionStat = []
      let xData = this.curMonthDays
      if (this.oneMonthAgoDays.length > this.curMonthDays.length) {
        xData = this.oneMonthAgoDays
      }
      _.forEach(xData, item => {
        const curStat = _.find(
          this.curMonthStat,
          e =>
            e.dimTimeId ===
            _.toNumber(`${this.curMonth}${(item + '').padStart(2, 0)}`)
        )
        if (curStat) {
          const {
            activeStudentIncrement = 0,
            paracraftActiveCount = 0,
            activeStudentTotal = 0,
            userActiveCount = 0,
            // vipTotal = 0,
            // vipActiveCount = 0,
            // vipIncrement = 0,
          } = curStat
          activeStudentIncrementList.push(activeStudentIncrement)
          activeStudentTotalList.push(activeStudentTotal)
          userActiveCountList.push(userActiveCount)
          // vipActiveCountList.push(vipActiveCount)
          // vipIncrementList.push(vipIncrement)
          // vipTotalList.push(vipTotal)
          curMonthActiveCountList.push(paracraftActiveCount)
        } else {
          activeStudentIncrementList.push(0)
          activeStudentTotalList.push(0)
          userActiveCountList.push(0)
          // vipActiveCountList.push(0)
          // vipIncrementList.push(0)
          // vipTotalList.push(0)
          curMonthActiveCountList.push(0)
        }
        const curOneMonthAgoStat = _.find(
          this.oneMonthAgoStat,
          e =>
            e.dimTimeId ===
            _.toNumber(`${this.oneMonthAgo}${(item + '').padStart(2, 0)}`)
        )
        if (curOneMonthAgoStat) {
          const { paracraftActiveCount = 0, userIncrement = 0 } =
            curOneMonthAgoStat
          oneMonthActiveCountList.push(paracraftActiveCount)
          userIncrementList.push(userIncrement)
          notChildUsersGrowByRegionStat.push(userIncrement)
        } else {
          oneMonthActiveCountList.push(0)
          userIncrementList.push(0)
          notChildUsersGrowByRegionStat.push(0)
        }
      })
      let childRegions = []
      let usersGrowByRegionStatList = []
      let studentByRegions = []
      let teacherByRegions = []
      const { studentTotal, teacherTotal } = this.overviewByRegion
      if (this.regionHasChild) {
        childRegions = this.regionChildList
        usersGrowByRegionStatList = _.map(this.regionChildList, regionName => {
          return _.map(this.oneMonthAgoDays, item => {
            const curOneMonthAgoChildStat = _.find(
              this.oneMonthAgoChildStat[regionName],
              e =>
                e.dimTimeId ===
                _.toNumber(`${this.oneMonthAgo}${(item + '').padStart(2, 0)}`)
            )
            if (curOneMonthAgoChildStat) {
              return curOneMonthAgoChildStat.userIncrement || 0
            } else {
              return 0
            }
          })
        })
        _.forEach(this.yesterdayChildStat, value => {
          if (value.length) {
            studentByRegions.push({
              value: value[0].studentTotal,
              name: value[0].name,
            })
            teacherByRegions.push({
              value: value[0].teacherTotal,
              name: value[0].name,
            })
          }
        })
      } else {
        childRegions = [this.regionName]
        usersGrowByRegionStatList = [notChildUsersGrowByRegionStat]
        studentByRegions = [{ value: studentTotal, name: this.regionName }]
        teacherByRegions = [{ value: teacherTotal, name: this.regionName }]
      }
      const activateUsersStat = initLine(
        'Paracraft激活用户统计',
        'activate-users-stat',
        [
          '激活学生增量',
          '激活学生总量',
          '激活用户数',
          // '激活vip数',
          // 'vip增量',
          // 'vip总数',
        ],
        this.curMonthDays,
        '单位: 人',
        [
          activeStudentIncrementList,
          activeStudentTotalList,
          userActiveCountList,
          // vipActiveCountList,
          // vipIncrementList,
          // vipTotalList,
        ],
        '单位: 日'
      )
      const activeUsersStat = initLine(
        '省份累计活跃用户月比较',
        'active-users-stat',
        ['本月累计活跃用户', '上一月累计活跃用户'],
        xData,
        '单位: 人',
        [curMonthActiveCountList, oneMonthActiveCountList],
        '单位: 日'
      )
      const usersGrowStat = initLine(
        '上月用户增长情况',
        'users-grow-stat',
        [],
        this.oneMonthAgoDays,
        '单位: 人',
        [userIncrementList],
        '单位: 日',
        true
      )
      const usersGrowByRegionStat = initLine(
        '上月用户增长情况（子区域）',
        'users-grow-by-region-stat',
        childRegions,
        this.oneMonthAgoDays,
        '单位: 人',
        usersGrowByRegionStatList,
        '单位: 日',
        true
      )
      const studentStat = initPie(
        '学生分布',
        'student-stat',
        '单位: 个',
        studentByRegions
      )
      const teacherStat = initPie(
        '教师分布',
        'teacher-stat',
        '单位: 个',
        teacherByRegions
      )
      return [
        activateUsersStat,
        activeUsersStat,
        usersGrowStat,
        usersGrowByRegionStat,
        studentStat,
        teacherStat,
      ]
    },
  },
  methods: {
    async init() {
      this.loading = true
      this.$nextTick(() => {
        _.forEach(this.chartList, item => {
          this.initChart(item.el, item.options)
        })
        this.loading = false
      })
    },
    initChart(el, options) {
      const node = document.getElementById(el)
      const myChart = echarts.init(node)
      myChart.clear()
      myChart.setOption(options)
    },
  },
}
</script>

<style lang='scss' scoped>
.stat-left {
  &-top {
    display: flex;
    flex-wrap: wrap;
    padding: 26px 38px 2px;
    box-sizing: border-box;
    &-item {
      flex: 50%;
      font-size: 14px;
      display: flex;
      align-items: center;
      margin-bottom: 18px;
      height: 38px;
      & > img {
        width: 50px;
        height: 50px;
        margin-right: 20px;
      }
      &-right-text {
        height: 14px;
        margin-bottom: 8px;
      }
      &-right-total {
        height: 14px;
        color: #0a95f5;
      }
    }
  }
  &-line {
    height: 0px;
    margin: 0 16px;
    border-bottom: 1px solid #495482;
  }
  &-charts {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 24px 0;
    box-sizing: border-box;
    justify-content: space-between;
    &-item {
      width: 316px;
      height: 250px;
      margin-bottom: 40px;
    }
  }
}
</style>